import type { ComponentProps } from 'solid-js'
import { styled } from 'styled-system/jsx'

export type SpanProps = ComponentProps<typeof Span>
export const Span = styled('span')
